// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rcti-supplier-shell {
  min-height: 100vh;
  background: var(--surface-secondary);
  color: var(--text-primary);
}
.rcti-supplier-content {
  max-width: 1248px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}
.rcti-supplier-content .rcti-detail-header {
  display: block;
}
.rcti-supplier-content .rcti-detail-header h1 {
  margin: 0;
  font-size: var(--font-size-h1);
}
.rcti-supplier-content .rcti-detail-context > div {
  min-width: 0;
}
.rcti-supplier-content a {
  overflow-wrap: anywhere;
}
.supplier-rcti-register {
  margin-bottom: var(--space-6);
  padding: var(--space-6);
  min-width: 0;
}
.supplier-rcti-register h2 {
  margin: 0;
  font-size: var(--font-size-body-lg);
}
.supplier-rcti-register p {
  font-size: var(--font-size-body-sm);
  line-height: 1.6;
}
.supplier-rcti-register-scroll {
  overflow-x: auto;
}
.supplier-rcti-register table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--font-size-body-sm);
}
.supplier-rcti-register :is(th, td) {
  text-align: left;
  padding: var(--space-3);
  border-bottom: 1px solid var(--border-subtle);
  white-space: nowrap;
}
.supplier-rcti-register th {
  color: var(--text-secondary);
  background: var(--surface-secondary);
  font-weight: var(--font-weight-medium);
}
.supplier-rcti-register td:nth-child(4) {
  font-family: var(--font-family-mono);
}
@media (max-width: 600px) {
  .supplier-rcti-register { padding: var(--space-4); }
  .supplier-rcti-register table, .supplier-rcti-register tbody { display: block; width: 100%; }
  .supplier-rcti-register thead { display: none; }
  .supplier-rcti-register tr { display: grid; grid-template-columns: minmax(0,1fr) auto; gap: var(--space-2) var(--space-3); padding-block: var(--space-4); border-bottom: 1px solid var(--border-subtle); }
  .supplier-rcti-register td { padding: 0; border: 0; min-width: 0; white-space: normal; }
  .supplier-rcti-register td:first-child { grid-column: 1; grid-row: 1; }
  .supplier-rcti-register td:nth-child(2) { grid-column: 1; grid-row: 2; color: var(--text-secondary); }
  .supplier-rcti-register td:nth-child(3) { grid-column: 1; grid-row: 3; color: var(--text-secondary); }
  .supplier-rcti-register td:nth-child(4) { grid-column: 2; grid-row: 1; text-align: right; }
  .supplier-rcti-register td:last-child { grid-column: 2; grid-row: 2 / span 2; align-self: center; }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/RCTI/supplierRcti.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,SAAS;EACT,mCAAmC;AACrC;AACA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,mCAAmC;AACrC;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,sCAAsC;AACxC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,0BAA0B,uBAAuB,EAAE;EACnD,+DAA+D,cAAc,EAAE,WAAW,EAAE;EAC5F,gCAAgC,aAAa,EAAE;EAC/C,6BAA6B,aAAa,EAAE,yCAAyC,EAAE,kCAAkC,EAAE,6BAA6B,EAAE,6CAA6C,EAAE;EACzM,6BAA6B,UAAU,EAAE,SAAS,EAAE,YAAY,EAAE,mBAAmB,EAAE;EACvF,yCAAyC,cAAc,EAAE,WAAW,EAAE;EACtE,0CAA0C,cAAc,EAAE,WAAW,EAAE,4BAA4B,EAAE;EACrG,0CAA0C,cAAc,EAAE,WAAW,EAAE,4BAA4B,EAAE;EACrG,0CAA0C,cAAc,EAAE,WAAW,EAAE,iBAAiB,EAAE;EAC1F,wCAAwC,cAAc,EAAE,oBAAoB,EAAE,kBAAkB,EAAE;AACpG","sourcesContent":[".rcti-supplier-shell {\n  min-height: 100vh;\n  background: var(--surface-secondary);\n  color: var(--text-primary);\n}\n.rcti-supplier-content {\n  max-width: 1248px;\n  margin: 0 auto;\n  width: 100%;\n  box-sizing: border-box;\n}\n.rcti-supplier-content .rcti-detail-header {\n  display: block;\n}\n.rcti-supplier-content .rcti-detail-header h1 {\n  margin: 0;\n  font-size: var(--font-size-h1);\n}\n.rcti-supplier-content .rcti-detail-context > div {\n  min-width: 0;\n}\n.rcti-supplier-content a {\n  overflow-wrap: anywhere;\n}\n.supplier-rcti-register {\n  margin-bottom: var(--space-6);\n  padding: var(--space-6);\n  min-width: 0;\n}\n.supplier-rcti-register h2 {\n  margin: 0;\n  font-size: var(--font-size-body-lg);\n}\n.supplier-rcti-register p {\n  font-size: var(--font-size-body-sm);\n  line-height: 1.6;\n}\n.supplier-rcti-register-scroll {\n  overflow-x: auto;\n}\n.supplier-rcti-register table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: var(--font-size-body-sm);\n}\n.supplier-rcti-register :is(th, td) {\n  text-align: left;\n  padding: var(--space-3);\n  border-bottom: 1px solid var(--border-subtle);\n  white-space: nowrap;\n}\n.supplier-rcti-register th {\n  color: var(--text-secondary);\n  background: var(--surface-secondary);\n  font-weight: var(--font-weight-medium);\n}\n.supplier-rcti-register td:nth-child(4) {\n  font-family: var(--font-family-mono);\n}\n@media (max-width: 600px) {\n  .supplier-rcti-register { padding: var(--space-4); }\n  .supplier-rcti-register table, .supplier-rcti-register tbody { display: block; width: 100%; }\n  .supplier-rcti-register thead { display: none; }\n  .supplier-rcti-register tr { display: grid; grid-template-columns: minmax(0,1fr) auto; gap: var(--space-2) var(--space-3); padding-block: var(--space-4); border-bottom: 1px solid var(--border-subtle); }\n  .supplier-rcti-register td { padding: 0; border: 0; min-width: 0; white-space: normal; }\n  .supplier-rcti-register td:first-child { grid-column: 1; grid-row: 1; }\n  .supplier-rcti-register td:nth-child(2) { grid-column: 1; grid-row: 2; color: var(--text-secondary); }\n  .supplier-rcti-register td:nth-child(3) { grid-column: 1; grid-row: 3; color: var(--text-secondary); }\n  .supplier-rcti-register td:nth-child(4) { grid-column: 2; grid-row: 1; text-align: right; }\n  .supplier-rcti-register td:last-child { grid-column: 2; grid-row: 2 / span 2; align-self: center; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
